export default () => ({
  show: false,

  close() {
    this.show = false;
    Grebify.noScroll(false);
  },

  toggle() {
    this.show = !this.show;
    Grebify.noScroll(!this.show);
  },
});
